import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { useEffect, useState } from "react";
import Errors from "../../models/errors";
import AccountingAccount, {
  newAccountingAccount,
} from "../../models/accounting-accounts";
import AccountingAccountForm from "./AccountingAccountForm";

interface AccountingAccountUpdateModalProps {
  show: boolean;
  accountingaccount?: AccountingAccount;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const AccountingAccountUpdateModal: React.FC<
  AccountingAccountUpdateModalProps
> = ({ show, accountingaccount, onCancel, onSuccess }) => {
  const [initialErrors, setInitialErrors] = useState<Errors>({});
  const [initialAccountingAccount, setInitialAccountingAccount] =
    useState<AccountingAccount>(
      accountingaccount ? accountingaccount : newAccountingAccount()
    );

  const modalTitle = accountingaccount
    ? `Editar Cuenta Contable: ${accountingaccount.name}`
    : `Crear Cuenta Contable Nueva`;

  const onClose = () => {
    setInitialErrors({});
    setInitialAccountingAccount(newAccountingAccount());
    onCancel();
  };
  useEffect(() => {
    setInitialAccountingAccount(
      accountingaccount ? accountingaccount : newAccountingAccount()
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountingaccount]);

  return (
    <CModal show={show} onClose={onClose} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>{modalTitle}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <AccountingAccountForm
            initialAccountingAccount={initialAccountingAccount}
            initialErrors={initialErrors}
            onCancel={onCancel}
            onSuccess={onSuccess}
          />
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default AccountingAccountUpdateModal;
